import React, { Component } from 'react';
// import * as Config from '../config/Config';
import * as Common from '../helpers/Common';
// import * as User from '../helpers/User';
import ChangePassword from './ChangePassword';
import ChangeProfile from './ChangeProfile';
const $= window.$;

class MyProfile extends Component {
	constructor(props) {
		super(props);
        // this.state={
        // };        
	}

	componentWillReceiveProps(next) {    
		$("#changeprofile").click();
	}

    componentDidMount() {
    	//alert('im in first');
		$('#parentHorizontalTab').easyResponsiveTabs({
            type: 'default', //Types: default, vertical, accordion
            width: 'auto', //auto or any width like 600px
            fit: true, // 100% fit in a container
            //closed: 'accordion', // Start closed if in accordion view
            tabidentify: 'hor_1', // The tab groups identifier
            activate: function (event) { // Callback function if tab is switched

                var $tab = $(this);
                var $info = $('#nested-tabInfo');
                var $name = $('span', $info);

                $name.text($tab.text());

                $info.show();
            }
        });
		// Common.showSmallLeftMenu();
    }

    // onChangedPro(val){
    // 	this.props.ChangeProf(val);
    // }

	render() {

		let is_careerlauncher = Common.getUserData('is_careerlauncher', true);
		const mcxclas = is_careerlauncher && "iscar";
		return (
			<section id="contentsection" className={`contentarea cl${mcxclas}`}>
				<div className="inner-title-bg journey-tit-bg">
					<h1><span><img src={process.env.PUBLIC_URL+"/images/img-my-account.jpg"} alt="" border="0" align="absmiddle" /></span>My Account<br /><span className="subtitle">Manage the profile</span></h1>
				</div>
				<div className="myperformance myobservers profilepage">
					<section id="semana-scroll-inner" className="scroll">
					 	<section className="scrollbar">
				        	<section className="track">
				        		<section className="thumb"></section>
			        		</section>
			        	</section>
					  	<section className="viewport">
						    <section className="overview">
						      	<div className="inner-content">
					            	<div id="parentHorizontalTab" >
							            <ul className="resp-tabs-list hor_1 horizontaltabbg">
							              	<li id="changeprofile">View / Edit profile
							                	<div className="activearrow"><img src={process.env.PUBLIC_URL+"/images/activetab.png"} alt="" border='0'/></div>
							              	</li>
							              	<li id="viewfeed">Change Password
							               		<div className="activearrow"><img src={process.env.PUBLIC_URL+"/images/activetab.png"} alt="" border='0'/></div>
							              	</li>
							            </ul>
						            	<div className="resp-tabs-container hor_1 tapmargntop">
						              		<div  className="tab-content">
						                 		<ChangeProfile />
						              		</div>
						              		<div className="tab-content" >
						              	 		<ChangePassword />
						              		</div>
						            	</div>
					            	</div>
						       	</div>
						    </section>
					  	</section>
					</section>
				</div>
			</section>

		);
	}
}

export default MyProfile;



// WEBPACK FOOTER //
// ./src/my_profile/MyProfile.js